module.exports = __webpack_public_path__ + "img/9.2f0905a6.jpg";